<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				雇主险出险-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
				<!-- 查询框 -->
				<span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
				<span style="font-size:20px;font-weight:700">人员信息</span>
				<div style="border:1px solid #DADADA;margin-top:10px"></div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<!-- <el-form-item label="姓名" prop="staff_id" style="margin-top:40px;width:80%">
								<el-select v-model="ruleForm.staff_id" style="width:100%" placeholder="请选择" filterable
									clearable @change="selectStaff">
									<el-option v-for="item in staffList" :key="item.id" :label="item.staff_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item> -->
							<div @click="StaffFind">
								<el-form-item label="姓名" prop="staff_id" style="margin-top:40px;width:80%">
									<el-input v-model="ruleForm.staff_name" onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
						</el-col>
						<el-col :span="12">
							<el-form-item label="身份证号" prop="staff_card" style="margin-top:40px;width:80%">
								<el-input v-model="ruleForm.staff_card" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="手机号" prop="staff_telephone" style="width:80%">
								<el-input v-model="ruleForm.staff_telephone" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="性别" prop="staff_gender" style="width:80%">
								<el-input v-model="ruleForm.staff_gender" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="年龄" prop="staff_age" style="width:80%">
								<el-input v-model="ruleForm.staff_age" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="岗位" prop="post_name" style="width:80%">
								<el-input v-model="ruleForm.post_name" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="城市" prop="city_id" style="width:80%">
								<el-input v-model="ruleForm.city_id" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="组织架构" style="width:80%">
								<el-input v-model="ruleForm.range" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>

					</el-row>

					<div style="margin-top:50px">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">出险信息</span>
						<div style="border:1px solid #DADADA;margin-top:10px"></div>

						<el-row>
							<el-col :span="12">
								<el-form-item label="出险时间" prop="danger_dete" style="margin-top:50px">
									<el-date-picker v-model="ruleForm.danger_dete" type="date" value-format="yyyy-MM-dd"
										style="width:73%" placeholder="请选择出险时间"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">

							</el-col>
						</el-row>

						<el-row>
							<el-col>
								<el-form-item label="出险经过" prop="danger_after" style="width:85%">
									<el-input type="textarea" :rows="2" v-model="ruleForm.danger_after"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col>
								<el-form-item label="事故照片" prop="accident_photo">
									<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
										:on-preview="sghandlePictureCardPreview" :limit="4" :on-remove="handleRemove"
										:file-list="ruleForm.accident_photo" :on-success="sghandleAvatarSuccess">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-dialog :visible.sync="dialogVisible">
										<img width="100%" :src="ruleForm.accident_photo" alt="">
									</el-dialog>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="报案号" prop="report_no" style="width:80%">
									<el-input v-model="ruleForm.report_no" placeholder="请输入报案号"></el-input>
								</el-form-item>
							</el-col>


							<el-col :span="12">
								<el-form-item label="保单号" prop="policy_no">
									<el-select v-model="ruleForm.policy_no" placeholder="请选择保单号"
										style="width:73%" clearable>
										<el-option v-for="item in Employer" :key="item.policy_no" :label="item.policy_no"
											:value="item.policy_no">
										</el-option>
									</el-select>

								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="理赔情况" prop="settlement_status">
									<el-select v-model="ruleForm.settlement_status" placeholder="请选择理赔情况"
										style="width:73%" @change="saveRules" clearable>
										<el-option v-for="item in ztList" :key="item.value" :label="item.label"
											:value="item.value"  >
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="医疗票据" prop="bill_url" style="width:80%">
									<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
										:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
										:file-list="ruleForm.bill_url" :on-success="handleAvatarSuccess">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-dialog :visible.sync="dialogVisible">
										<img width="100%" :src="ruleForm.bill_url" alt="">
									</el-dialog>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="收保险公司理赔款" prop="settlement_amount" style="width:80%">
									<el-input type="number" v-model="ruleForm.settlement_amount" placeholder="请输入收保险公司理赔款"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="付员工理赔款" prop="indemnity_amount" style="width:80%">
									<el-input type="number" v-model="ruleForm.indemnity_amount" placeholder="请输入付员工理赔款"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="结案日期" prop="close_date">
									<el-date-picker v-model="ruleForm.close_date" type="date" value-format="yyyy-MM-dd"
										style="width:73%" placeholder="请选择结案日期"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="情况备注" prop="remarks" style="width:80%">
									<el-input v-model="ruleForm.remarks" placeholder="请填写备注"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>


					<el-form-item style="margin-left:400px;margin-top:50px">
						<el-button type="goon" @click="submitForm('ruleForm')"
							v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
						<el-button type="goon" @click="Update('ruleForm')"
							v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
		<el-dialog title="选择姓名" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="true"
			:show-close="false" :modal-append-to-body="false" :append-to-body="true">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	export default {
		components: {
            organizeStaff: organizeStaff,
        },
		props: ["staffList"],
		data() {
			return {
				dialogVisibles:false,
				ruleForm: {
					id: '',
					company_id: '',
					staff_id: '',
					staff_card: '',
					staff_telephone: '',
					company_name: '',
					modular_name: '',
					staff_gender: '',
					staff_age: '',
					project_name: '',
					city_id: '',
					post_name: '',
					danger_dete: '',
					danger_after: '',
					report_no: '',
					policy_no: '',
					settlement_amount: '',
					indemnity_amount: '',
					close_date: '',
					remarks: '',
					bill_url: '',
					settlement_status: '',
					accident_photo: [],
					type: [],


				},

				//保单
				Employer:[],

				//状态下拉
				ztList: [{
					value: '0',
					label: '未理赔'
				}, {
					value: '1',
					label: '已理赔'
				}, {
					value: '2',
					label: '已撤案'
				}],
				
				// rules:{},

				rules: {
					staff_id: [{
						required: true,
						message: '请选择姓名',
						trigger: 'blur'
					}, ],
					
					danger_dete: [{
						required: true,
						message: '请选择出险时间',
						trigger: 'blur'
					}, ],
					danger_after: [{
						required: true,
						message: '请输入出险经过',
						trigger: 'blur'
					}, ],
					report_no: [{
						required: true,
						message: '请输入报案号',
						trigger: 'blur'
					}, ],
					policy_no: [{
						required: true,
						message: '请输入保单号',
						trigger: 'blur'
					}, ],
					staff_id: [{
						required: true,
						message: '请选择姓名',
						trigger: 'blur'
					}, ],
					// accident_photo: [
					//   { required: true, message: '请上传事故照片', trigger: 'blur' },
					// ],
					settlement_status: [{
						required: true,
						message: '请选择理赔情况',
						trigger: 'blur'
					}, ],


					// bill_url: [{
					// 	required: true,
					// 	message: '请上传医疗票据',
					// 	trigger: 'change'
					// }, ],
					// settlement_amount: [{
					// 	required: true,
					// 	message: '请输入收保险公司理赔款',
					// 	trigger: 'blur'
					// }, ],
					// indemnity_amount: [{
					// 	required: true,
					// 	message: '请输入付员工理赔款',
					// 	trigger: 'blur'
					// }, ],
					// close_date: [{
					// 	required: true,
					// 	message: '请输入结案日期',
					// 	trigger: 'blur'
					// }, ],
				}



			};
		},
		methods: {
			//获取
			selectStaff() {
				this.$props["staffList"].forEach(item => {
					if (item.id === this.ruleForm.staff_id) {
						this.ruleForm.staff_card = item.staff_card;
						this.ruleForm.staff_telephone = item.staff_telephone;
						this.ruleForm.range = item.range;
						this.ruleForm.city_id = item.city_id;
						this.ruleForm.post_name = item.post_name;
						this.ruleForm.staff_gender = item.staff_gender;
						this.ruleForm.staff_age = item.staff_age;
						debugger
					}
				})
			},
			StaffFind() {
				this.dialogVisibles = true;
			},
			saveRules(){
				if(this.ruleForm.settlement_status == '0' || this.ruleForm.settlement_status == '2' ){
					this.rules={};
					this.rules={
						staff_id:[{
							required: true,
							message: '请选择姓名',
							trigger: 'blur'
						}, ],
						danger_dete: [{
							required: true,
							message: '请选择出险时间',
							trigger: 'blur'
						}, ],
						danger_after: [{
							required: true,
							message: '请输入出险经过',
							trigger: 'blur'
						}, ],
						report_no: [{
							required: true,
							message: '请输入报案号',
							trigger: 'blur'
						}, ],
						policy_no:[{
							required: true,
							message: '请输入保单号',
							trigger: 'blur'
						}, ],
						staff_id:[{
							required: true,
							message: '请选择姓名',
							trigger: 'blur'
						}, ],
						settlement_status:[{
							required: true,
							message: '请选择理赔情况',
							trigger: 'blur'
						}, ],
					}
				}else{
					this.rules={};
					this.rules={	
						staff_id:[{
							required: true,
							message: '请选择姓名',
							trigger: 'blur'
						}, ],
						danger_dete: [{
							required: true,
							message: '请选择出险时间',
							trigger: 'blur'
						}, ],
						danger_after:[{
							required: true,
							message: '请输入出险经过',
							trigger: 'blur'
						}, ],
						report_no: [{
							required: true,
							message: '请输入报案号',
							trigger: 'blur'
						}, ],
						policy_no:[{
							required: true,
							message: '请输入保单号',
							trigger: 'blur'
						}, ],
						staff_id:[{
							required: true,
							message: '请选择姓名',
							trigger: 'blur'
						}, ],
						settlement_status:[{
							required: true,
							message: '请选择理赔情况',
							trigger: 'blur'
						}, ],
						bill_url:[{
							required: true,
							message: '请上传医疗票据',
							trigger: 'change'
						}, ],
						settlement_amount: [{
							required: true,
							message: '请输入收保险公司理赔款',
							trigger: 'blur'
						}, ],
						indemnity_amount: [{
							required: true,
							message: '请输入付员工理赔款',
							trigger: 'blur'
						}, ],
						close_date: [{
							required: true,
							message: '请输入结案日期',
							trigger: 'blur'
						}, ],
					}

				}

			},
			//设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.staff_name = e.staff_name;
				this.ObtainEmployer(e.staff_id);
				this.dialogVisibles = false;
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.bill_url = res.data.fileUrl;
			},
			sghandleAvatarSuccess(res, file) {
				this.ruleForm.accident_photo.push(res.data.fileUrl)

			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			sghandlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},

			//新增
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var accident_photo = ""; 
						this.ruleForm.accident_photo.forEach(item => {
							accident_photo += ";" + item;
						})
						var url = 'Danger/insert';
						var record = {
							company_id: this.ruleForm.company_id,
							staff_id: this.ruleForm.staff_id,
							staff_card: this.ruleForm.staff_card,
							staff_telephone: this.ruleForm.staff_telephone,
							company_name: this.ruleForm.company_name,
							modular_name: this.ruleForm.modular_name,
							city_id: this.ruleForm.city_id,
							staff_gender: this.ruleForm.staff_gender,
							staff_age: this.ruleForm.staff_age,
							project_name: this.ruleForm.project_name,
							post_name: this.ruleForm.post_name,
							danger_dete: this.ruleForm.danger_dete,
							danger_after: this.ruleForm.danger_after,
							report_no: this.ruleForm.report_no,
							policy_no: this.ruleForm.policy_no,
							settlement_amount: this.ruleForm.settlement_amount,
							indemnity_amount: this.ruleForm.indemnity_amount,
							close_date: this.ruleForm.close_date,
							remarks: this.ruleForm.remarks,
							bill_url: this.ruleForm.bill_url,
							accident_photo: accident_photo,
							settlement_status: this.ruleForm.settlement_status,
							applicant_id:this.$globals.user.staff_id,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 修改
			Update(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var url = 'Danger/update';
						var record = {
							id: this.ruleForm.id,
							company_id: this.ruleForm.company_id,
							staff_id: this.ruleForm.staff_id,
							staff_card: this.ruleForm.staff_card,
							staff_telephone: this.ruleForm.staff_telephone,
							company_name: this.ruleForm.company_name,
							modular_name: this.ruleForm.modular_name,
							city_id: this.ruleForm.city_id,
							staff_gender: this.ruleForm.staff_gender,
							staff_age: this.ruleForm.staff_age,
							project_name: this.ruleForm.project_name,
							post_name: this.ruleForm.post_name,
							danger_dete: this.ruleForm.danger_dete,
							danger_after: this.ruleForm.danger_after,
							report_no: this.ruleForm.report_no,
							policy_no: this.ruleForm.policy_no,
							settlement_amount: this.ruleForm.settlement_amount,
							indemnity_amount: this.ruleForm.indemnity_amount,
							close_date: this.ruleForm.close_date,
							remarks: this.ruleForm.remarks,
							bill_url: this.ruleForm.bill_url,
							accident_photo: this.ruleForm.accident_photo,
							settlement_status: this.ruleForm.settlement_status,
							applicant_id:this.$globals.user.staff_id,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			Return() {
				this.$parent.Return();
			},

			async ObtainEmployer(Staff_id){
				var url = 'EmployerDetailed/selectEmployer';
				var record = {
					staff_id: Staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.Employer=data;
					} else {
						this.$message.warning(data);
					}
				}


			},


		},
		created() {
			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.staff_id"(newValue) {
				this.selectStaff();
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Gzxcx_add.vue?fa40bfa8